// extracted by mini-css-extract-plugin
module.exports = {"innerInput":"style_innerInput__doi6J","subjectInput":"style_subjectInput__TTVQ5","descriptionInput":"style_descriptionInput__pTu6h","errorColor":"style_errorColor__8zdHQ"};